import { apiClient } from './api';

interface Tenant {
  id: string;
  name: string;
  status: 'active' | 'suspended' | 'inactive';
  createdAt: string;
  updatedAt: string;
  settings: Record<string, any>;
}

interface CreateTenantRequest {
  name: string;
  description?: string;
  ownerEmail: string;
}

class TenantService {
  async getAllTenants(): Promise<Tenant[]> {
    return await apiClient.get<Tenant[]>('/tenants');
  }

  async getTenantById(id: string): Promise<Tenant> {
    return await apiClient.get<Tenant>(`/tenants/${id}`);
  }

  async createTenant(data: CreateTenantRequest): Promise<Tenant> {
    return await apiClient.post<Tenant>('/tenants', data);
  }

  async updateTenant(id: string, data: Partial<Tenant>): Promise<Tenant> {
    return await apiClient.put<Tenant>(`/tenants/${id}`, data);
  }

  async deleteTenant(id: string): Promise<void> {
    await apiClient.delete(`/tenants/${id}`);
  }

  async switchTenant(id: string): Promise<void> {
    await apiClient.post(`/tenants/switch`, { tenantId: id });
  }
}

export const tenantService = new TenantService();
